/* eslint-disable */
// @ts-nocheck
import { ghb } from "@cervval.js/i18n/src/i18n.tools";

export const i18n = {
    changePassword: {
        innerText: "Change Password"
    },
    changePasswordTitle: {
        title: "Change Password"
    },
    confirmChange: {
        innerHTML: "Confirm change"
    },
    firstPassword: {
        label: "Password"
    },
    minLengthRequirement: {
        innerText: "Minimal Length"
    },
    minLowercaseRequirement: {
        innerText: "Lowercases"
    },
    minNumberRequirement: {
        innerText: "Numbers"
    },
    minSpecialRequirement: {
        innerText: "Special caracters"
    },
    minUppercaseRequirement: {
        innerText: "Uppercases"
    },
    passwordMatchRequirement: {
        innerText: "Password matches"
    },
    secondPassword: {
        label: "Confirm password"
    },
    tmpPasswordLabel: {
        label: "Change password on next login"
    }
};